import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { 
	UNAUTHENTICATED_ENTRY, 
	REDIRECT_URL_KEY,
	WORKSPACE_BASE_PATH,
	MARKETER_BASE_PATH,
	isMarketerUser,
	isWorkspaceOnlyUser,
	getPostAuthRoute,
} from 'configs/AppConfig'

const ProtectedRoute = () => {
	
	const { token, user } = useSelector(state => state.auth)
	const location = useLocation()
	const storedUser = (() => {
		try {
			return JSON.parse(localStorage.getItem('auth_user') || 'null');
		} catch {
			return null;
		}
	})();
	const authUser = user || storedUser;

	if (!token) {
		return <Navigate to={`${UNAUTHENTICATED_ENTRY}?${REDIRECT_URL_KEY}=${location.pathname}`} replace />;
	}

	const dest = getPostAuthRoute(authUser);

	// Field marketers are locked to the Marketers Portal (takes precedence over workspace-only).
	if (isMarketerUser(authUser) && !location.pathname.startsWith(MARKETER_BASE_PATH)) {
		return <Navigate to={dest} replace />;
	}

	// Non-marketers (including super admin) are kept out of the Field CRM shell.
	if (!isMarketerUser(authUser) && location.pathname.startsWith(MARKETER_BASE_PATH)) {
		return <Navigate to={dest} replace />;
	}

	// Notes/workspace-only users are locked to the Workspace Editor area.
	if (isWorkspaceOnlyUser(authUser) && !location.pathname.startsWith(WORKSPACE_BASE_PATH)) {
		return <Navigate to={dest} replace />;
	}

	return <Outlet />
}

export default ProtectedRoute
